import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import App from './App';
import ErrorBoundary from './ErrorBoundary';
import theme from './theme';
import { AuthProvider } from "./context/AuthContext";


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
          <AuthProvider>
            <App />
          </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);